import { Box, ButtonGroup, IconButton, Menu, Paragraph } from '@zillow/constellation-10';
import { IconChevronLeftFilled, IconChevronRightFilled } from '@zillow/constellation-icons';

type Props = {
  currentPageNumber: number;
  currentRowsPerPage: number;
  handleNextPageClick: () => void;
  handlePreviousPageClick: () => void;
  handleRowsPerPageClick: (rowsPerPageOption: number) => void;
  hasError: boolean;
  isLastPage: boolean;
};

export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50] as const;
export const DEFAULT_ROWS_PER_PAGE = ROWS_PER_PAGE_OPTIONS[0];

export default function TableFooter({
  currentPageNumber,
  currentRowsPerPage,
  handleNextPageClick,
  handlePreviousPageClick,
  handleRowsPerPageClick,
  hasError,
  isLastPage,
}: Props) {
  const shouldShowRowsPerPage =
    !(isLastPage && currentPageNumber === 1 && currentRowsPerPage === DEFAULT_ROWS_PER_PAGE) && !hasError;

  const rowsPerPageMenu = (
    <>
      {ROWS_PER_PAGE_OPTIONS.map((rowsPerPageOption) => (
        <Menu.Item onClick={() => handleRowsPerPageClick(rowsPerPageOption)} key={rowsPerPageOption}>
          {rowsPerPageOption}
        </Menu.Item>
      ))}
    </>
  );

  return (
    <Box css={{ marginTop: 'loose', position: 'relative' }}>
      <ButtonGroup aria-label="Pagination" css={{ display: 'flex', justifyContent: 'center' }}>
        <IconButton
          disabled={currentPageNumber === 1}
          emphasis="outlined"
          icon={<IconChevronLeftFilled />}
          onClick={handlePreviousPageClick}
          shape="circle"
          size="sm"
          title="Previous"
          tone="neutral"
        />

        <IconButton
          disabled={isLastPage || hasError}
          emphasis="outlined"
          icon={<IconChevronRightFilled />}
          onClick={handleNextPageClick}
          shape="circle"
          size="sm"
          title="Next"
          tone="neutral"
        />
      </ButtonGroup>

      {shouldShowRowsPerPage && (
        <Box
          css={{
            display: 'flex',
            alignItems: 'center',
            xl: { position: 'absolute', right: 0, top: '-5px', zIndex: 1 },
            xlDown: { justifyContent: 'center', marginTop: 'looser' },
          }}
        >
          <Paragraph textStyle="body-sm" css={{ paddingRight: 'tighter' }}>
            Rows per page
          </Paragraph>

          <Menu content={rowsPerPageMenu} trigger={<Menu.Button size="sm">{currentRowsPerPage}</Menu.Button>} />
        </Box>
      )}
    </Box>
  );
}
